<script setup lang="ts">
import { t } from '@/i18n'

// Icons are positional: 0 = privacy/no-upload, 1 = free, 2 = any device
const icons = [
  // shield-lock
  'M5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.8 11.8 0 0 1-2.517 2.453 7 7 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7 7 0 0 1-1.048-.625 11.8 11.8 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 63 63 0 0 1 5.072.56M8 5a1.5 1.5 0 0 1 .5 2.915l.385 1.99a.5.5 0 0 1-.491.595h-.788a.5.5 0 0 1-.49-.595l.384-1.99A1.5 1.5 0 0 1 8 5',
  // check-circle
  'M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1m3.844 4.146a.5.5 0 0 1 .01.708l-4.5 4.75a.5.5 0 0 1-.722.006L4.146 8.146a.5.5 0 1 1 .708-.707l2.122 2.12 4.16-4.393a.5.5 0 0 1 .708-.02',
  // phone + screen
  'M11 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM5 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm3 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2'
]
</script>

<template>
  <section class="trust-section" :aria-label="t.trustItems[0]?.title">
    <div class="trust-grid">
      <div v-for="(item, i) in t.trustItems" :key="i" class="trust-card">
        <div class="trust-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
            <path :d="icons[i] ?? icons[0]" />
          </svg>
        </div>
        <h2 class="trust-title">{{ item.title }}</h2>
        <p>{{ item.text }}</p>
      </div>
    </div>
  </section>
</template>

<style scoped>
.trust-section {
  margin-top: 2rem;
}

.trust-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1rem;
}

.trust-card {
  text-align: center;
  padding: 1.25rem 1rem;
  background: var(--card-background);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
}

.trust-icon {
  color: var(--success-color);
  margin-bottom: 0.75rem;
  display: flex;
  justify-content: center;
}

.trust-card h2.trust-title {
  font-size: 1rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
  color: var(--text-primary);
}

.trust-card p {
  margin: 0;
  font-size: 0.875rem;
  color: var(--text-secondary);
  line-height: 1.5;
}

@media (max-width: 480px) {
  .trust-grid {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }
}
</style>
